export default __webpack_public_path__ + "static/media/bell.5d2f6a0d.svg";